import { state } from './state';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const validation = {
  state,
  actions,
  getters,
  mutations,
};

export default validation;
